import { createContext } from 'react';

export type NavigationContextProps = {
  toggleSideNavigation: () => void;
  toggleMobileSideNavigation: () => void;
  sideNavigationOpen: boolean;
  mobileSideNavigationOpen: boolean;
};

export const SidePanelsContext = createContext<NavigationContextProps>({
  toggleSideNavigation: () => {},
  toggleMobileSideNavigation: () => {},
  sideNavigationOpen: true,
  mobileSideNavigationOpen: false,
});
